import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingAkanaService {

  returnValue = new EventEmitter<boolean>(false);
  value = false;

  constructor() { }

  setShowLoading = (value) => {
    this.returnValue.emit(value);
  }


  setValue = (v) => {
    this.value = v;
  }

  getValue = () => {
    return this.value;
  }
}
